/** Editorial presentation copy; verified programme facts live in site.ts. */
export const design = {
  heroNote: "Rooted in wisdom. Lived through practice.",
  invitation: "Find your connection",
  paths: [
    { title: "Learn & practise", description: "Vedic learning and initiation", href: "#initiatives", icon: "book" },
    { title: "Read & reflect", description: "Teachings from the tradition", href: "/articles/", icon: "reading" },
    { title: "Gather & celebrate", description: "Observances and Mission events", href: "/events/", icon: "calendar" },
    { title: "Life at the Mission", description: "Moments of learning and seva", href: "/gallery/", icon: "images" },
  ],
  quote: "uttiṣṭhata mā svapta, agnim icchadhvaṃ bhāratāḥ",
  quoteMeaning: ["O Bhāratas: arise, awake,", "and worship Agni."],
} as const;
